import React, { useState } from 'react';

import { SearchOutlined } from '@ant-design/icons';

import { StyledButton } from '../../components/Button';
import { MainTablePage } from '../../components/MainTablePage';
import { iconColors } from '../../icons/Icon';
import { PageRoutesEnum } from '../../utils/routes';
import { SimilarProjectsModal } from '../project-details/SimilarProjectsModal';

import { ProjectsSearchForm } from './ProjectsSearchForm';
import { useDeleteProjectFilter } from './useDeleteProjectFilter';
import { useGetProjectFilters } from './useGetProjectsFilters';
import { useProjectsTableColumnDefinitions } from './useProjectsTableColumnDefinitions';
import { useProjectsTableDataSource } from './useProjectsTableDataSource';
import { useSaveProjectFilter } from './useSaveProjectFilter';
import { useSearchProjects } from './useSearchProjects';
import { useUpdateProjectFilter } from './useUpdateProjectFilter';

export const ProjectsPage: React.FC = () => {
  const [isSimilarModalOpen, setIsSimilarModalOpen] = useState(false);

  return (
    <>
      <MainTablePage
        getFilters={useGetProjectFilters}
        saveFilter={useSaveProjectFilter}
        updateFilter={useUpdateProjectFilter}
        deleteFilter={useDeleteProjectFilter}
        getColumnsDefinition={useProjectsTableColumnDefinitions}
        search={useSearchProjects}
        getDataSource={useProjectsTableDataSource}
        storedFilterName="projectsFilter"
        storedPagingData="projectsPaging"
        title="Projects"
        searchForm={ProjectsSearchForm}
        addPageRoute={PageRoutesEnum.projectAdd}
        headerActions={
          <StyledButton
            icon={<SearchOutlined style={{ color: `${iconColors.blue_20}`, fontSize: '16px' }} />}
            onClick={() => setIsSimilarModalOpen(true)}
          >
            Search by Query
          </StyledButton>
        }
      />
      <SimilarProjectsModal
        open={isSimilarModalOpen}
        onClose={() => setIsSimilarModalOpen(false)}
        defaultSource="query"
        allowProjectSource={false}
      />
    </>
  );
};
